var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5.5,
    r: 2.5,
    stroke: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 12v1.5h1V12h-1zm0 1.5H2v1h9v-1zm-9 0V12H1v1.5h1zM4 10h5V9H4v1zm-2 3.5H1a1 1 0 001 1v-1zm9 0v1a1 1 0 001-1h-1zm1-1.5a3 3 0 00-3-3v1a2 2 0 012 2h1zM2 12a2 2 0 012-2V9a3 3 0 00-3 3h1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.866 1.732a2.5 2.5 0 111.985 4.589M10.85 8h1.57a2.5 2.5 0 012.5 2.5V12a.5.5 0 01-.5.5h-.92",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan2.c5024531.svg";
export { SvgTongyongRenyuan2 as ReactComponent };